import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Corporate.css';
import PolitikaPDF from '../Erşan Döviz Kurum POLİTİKA- Aklama-Ter.Fin- Kitle İmha Silah. Yay. Fin. ile Müc..pdf';

const Corporate = () => {
  return (
    <div className="corporate">
      <Helmet>
        <title>Kurumsal | Erşan Döviz</title>
        <meta name="description" content="Erşan Döviz Kurumsal sayfası." />
        <link rel="canonical" href="https://ersandoviz.com/kurumsal" />
      </Helmet>

      {/* Hero Section */}
      <section className="corporate-hero">
        <div className="container">
          <div className="corporate-hero-content text-center">
            <h1 className="corporate-title">Kurumsal</h1>           
          </div>
        </div>
      </section>

      {/* Corporate Content */}
      <section className="corporate-content section-padding">
        <div className="container">
          <div className="corporate-document">
            
            <div className="corporate-section">
              <h2 className="section-title">Kurumsal Politikalarımız</h2>
              <div className="section-content">
                <p>
                  Suç Gelirlerinin Aklanması, Terörizmin Finansmanı ve Kitle İmha Silahlarının Yayılmasının Finansmanı ile Mücadelede KURUM Politikamız… 
                  <a href={PolitikaPDF} className="policy-link" target="_blank" rel="noopener noreferrer">TIKLAYINIZ</a>
                </p>
              </div>
            </div>

            <div className="corporate-section">
              <h2 className="section-title">Müşteri Tanı</h2>
              <div className="section-content">
                <p>
                  <strong>ERŞAN YETKİLİ MÜESSESE ANONİM</strong> Şirketimiz, 5549 sayılı Suç Gelirlerinin Aklanmasının Önlenmesi Hakkında Kanun ve ilişkili mevzuat gereğince, Müşterinin Tanınmasına ilişkin Esaslara uygun şekilde Müşteri Kabul Politikası uygular.
                </p>
                <p>
                  Şirket, müşterinin tanınması politikası çerçevesinde, kimlik tespitine ilişkin olarak; yasal düzenlemelerde belirlenen/istenen bilgi ve belgeleri, tespit ve teyit eder, belgelerin kendi içinde tutarlı olup, olmadığına dikkat eder, müşterinin Şirketi tercih etme sebebi, mesleği, gelir getiren ana iş konusu, işyeri, faaliyet yeri konularında bilgi sahibi olur.
                </p>
              </div>
            </div>

            <div className="corporate-section">
              <h2 className="section-title">Hesap Açılışı/İş İlişkisi</h2>
              <div className="section-content">
                <p>
                  Hesap Açılışı/İş İlişkisi Başlatmak için gerekli FORM / DÖKÜMANLAR için, irtibata geçiniz.
                </p>
                <div className="contact-info-corporate">
                  <div className="contact-item-corporate">
                    <strong>Tel:</strong> <a href="tel:+902322771281">0 232 277 12 81</a>
                  </div>
                  <div className="contact-item-corporate">
                    <strong>Email:</strong> <a href="mailto:info@ersandoviz.com">info@ersandoviz.com</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Corporate;